import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { storage } from '../../helpers/storage';

const Permiso = ({perfil}) => {

    let _perfil =  storage.get('perfilid');
    
    let navigate = useNavigate();

    useEffect(() => {
        console.log(_perfil + "===" + perfil);
        //if (_perfil === perfil) {
           // navigate("/dashboardu");
       // }
    }, [_perfil]);
}

export default Permiso;